module.exports = __webpack_public_path__ + "static/media/401.b027613d.webp";